import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { fetchHomepage, fetchObjectpage } from "../Redux/slice/homeSlice";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ScrollContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

const ScrollInner = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 20px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: none;
  width: 40px;
  height: 60px;
  cursor: pointer;
  font-size: 24px;
  border-radius: 4px;

  ${(props) => props.left && "left: 10px;"}
  ${(props) => props.right && "right: 10px;"}
  @media (max-width: 768px) {
    display: none; /* hide arrows on small screens */
  }
`;

const Card = styled.div`
  position: relative;
  width: 300px;
  height: auto;
  overflow: hidden;
  cursor: pointer;
  border-radius: 12px;
  background-color: ${(props) => props.bgColor || "#fff"};
  transition: background-color 0.5s ease;
  flex: 0 0 auto; /* do not shrink or grow */
`;

const Background = styled.div`
  position: absolute;
  inset: 0;
  background-image: ${(props) => `url(${props.bg})`};
  background-size: cover;
  background-position: center;
  z-index: 1;
  transition: transform 0.5s ease;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4); /* dark overlay */
  }

  ${Card}:hover & {
    transform: translateY(100%);
  }
`;

const OverlayImage = styled.img`
  position: absolute;
  bottom: 20px;
  left: 40%;
  transform: translateX(-50%);
  z-index: 2;
  width: 141px;
  height: 141px;
  transition: opacity 0.5s ease, transform 0.5s ease;

  ${Card}:hover & {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 3;
  color: #fff;
  padding: 20px;
  opacity: 0;
  transition: opacity 0.5s ease;

  ${Card}:hover & {
    opacity: 1;
  }
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  button {
    background: transparent;
    font-size: 16px;
    font-weight: 600;
    height: 50px;
    width: 150px;
    color: #ffffff;
    border: 1px solid #ffffff;
    margin-top: 10px;
  }
`;

// Add Number, Title, Paragraph, Stats, StatItem as before...

const Number = styled.div`
  font-size: 3rem;
  font-weight: bold;
  opacity: 0.4;
`;

const Title = styled.h3`
  margin: 5px 0;
  font-size: 20px;
  font-weight: 700;
`;

const Paragraph = styled.p`
  font-size: 14px;
  line-height: 23px;
  font-weight: 450;
`;

const Stats = styled.div`
  margin-top: 15px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  flex-wrap: wrap;
  border-top: 1px solid #ffffff2e;
  padding-top: 15px;
`;

const StatItem = styled.div`
  font-size: 30px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  gap: 3px;
  p {
    font-size: 14px;
    font-weight: 400;
  }
`;

const HomeRap = styled.div`
  .home-1 {
    /* background-size: cover;
    background-repeat: no-repeat; */
    height: 100vh;
    width: 100%;
       border-radius: 24px;

    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 100px;
    padding-left: 50px;
    gap: 20px;
  }

.slider-wrapper {
    padding: 0px 20px;
}
  .home-1-img-banner {
    width: 100vw;
    height: 100vh;
  }

  .get-in-touch {
    background: #e77817;
    width: 231px;
    height: 48px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    text-decoration: none;
  }

  .home-1 h1 {
    color: #ffffff;
    font-size: 50px;
    font-weight: 600;
    max-width: 720px;
    line-height: 55px;
  }
  .home-1 p {
    color: #ffffffb2;
    font-weight: 450;
    font-size: 18px;
    max-width: 427px;
  }
  /* .home-1 img {
    position: absolute;
    bottom: -20px;
    left: 150px;
  } */
  .home-2 h4 {
    color: #34302f;
    max-width: 167px;
    font-size: 20px;
    font-weight: 600;
  }
  .home-2-sub p,
  .over-4-header p {
    color: #34302f;
    font-size: 14px;
    font-weight: 450;
  }
  .home-2-sub {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 198px;
    height: 160px;
    justify-content: center;
    border-left: 1px solid #e4e4e4;
    align-items: center;
  }
  .home-2 {
    border-bottom: 1px solid #e4e4e4;
    display: flex;

    align-items: center;
    justify-content: center;
  }
  .over-4-header p {
    max-width: 480px;
    line-height: 23px;
    text-align: justify;
  }
  .over-4-header {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .over-4-header h4 {
    color: #121212;
    font-size: 50px;
    font-weight: 600;
  }
  .over-4-header-all p {
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    max-width: 516px;
  }
   .over-4-header-all {
    display: flex;
    justify-content: space-between;
    gap: 20px;
   }
  .over-4-header button {
    background: #e06f29;
    width: 166px;
    height: 52px;
    border-style: none;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
  }

  .over-4-inner {
    display: flex;
    gap: 20px;
  }

  .over-4-inner img {
    width: 250px;
    height: 200px;
  }
  .modal-overlay {
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .modal-content {
    position: relative;
    background: #fff;
    padding: 10px;
    border-radius: 8px;
    width: 90%;
    height: 80%;
  }

  .modal-content img {
    width: 100%;
    max-height: 70vh;
    border-radius: 4px;
  }

  .close-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    background: red;
    color: white;
    border: none;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    cursor: pointer;
    font-size: 16px;
  }

  .img-magin {
    margin-right: 20px;
  }
  .over-4 {
    display: flex;
    flex-direction: column;
    gap: 50px;
    margin: 100px 0px;
  }
  .gallery-container {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;
    margin: 20px 0;
  }

  .gallery-slider {
    overflow: hidden;
    width: 100%;
  }

  .gallery-inner {
    display: flex;
    gap: 20px;
    width: fit-content;
    transition: transform 0.3s ease-in-out;
  }

  .gallery-img {
    width: 100%;
    height: 320px;
    object-fit: cover;
    margin-right: 5px;
    flex-shrink: 0;
    border-radius: 8px;
    cursor: pointer;
  }
  .banner-wrapper {
    position: relative;
    width: 100%;
    height: auto;
    cursor: pointer;
  }

  .banner-link {
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    color: #e77817;
    margin: 20px;
    margin-top: 0px;
    padding-bottom: 20px !important;
    margin-bottom: 20px !important;
  }

  .play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 48px;
    color: red;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .galery-div {
    width: 40%;
    flex: 0 0 50%; /* Each item takes 50% of container */
  box-sizing: border-box;
    height: auto;
    border-radius: 8px;
    background: #ffffff;
    padding-bottom: 20px;
  }
  .galery-div p {
    font-size: 18px;
    margin: 20px;
    font-weight: 400;
    max-width: 592px;
    line-height: 28px;
  }
  .nav-btn {
    background-color: white;
    width: 40px;
    height: 40px;
    position: absolute;
    border-radius: 50%;
    cursor: pointer;
    z-index: 1;
  }

  .left-btn {
    left: 10px;
  }

  .right-btn {
    right: 10px;
  }

  .modal-overlay {
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .modal-content {
    position: relative;
    background: #fff;
    padding: 10px;
    border-radius: 8px;
    max-width: 55%;
    max-height: 90%;
  }

  .modal-content img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  .close-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    background: red;
    color: white;
    border: none;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    cursor: pointer;
    font-size: 16px;
  }
  .more-experi p {
    color: #34302f !important;
    font-size: 16px;
    font-weight: 450;
  }
  .more-experi {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .sub-home-3 {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .sub-home-3 h2 {
    max-width: 436px;
    font-size: 50px;
    font-weight: 600;
    line-height: 55px;
    color: #121212;
  }
  .orange-p {
    color: #e77817 !important;
    font-size: 16px;
    font-weight: 450;
  }
  .sub-home-3 p {
    color: #282735;
    font-size: 18px;
    font-weight: 400;
    max-width: 550px;
    line-height: 28px;
   
  }
  .home-3 {
    padding-top: 80px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
  }
   .home-3 img, .about-3 img {
    max-width: 576px;
    border-radius: 16px;
   }
  .circle-arrow {
    box-shadow: 0px 0px 25px 0px #00000014;
    background: #ffffff;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-right-arrows {
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: space-between;
    position: absolute;
    top: 50%;
  }
  .circle-arrow-one {
    position: absolute;
    left: -30px;
    top: 50%;
    z-index: 1000;
  }
    .circle-arrow-two {
    position: absolute;
    right: -30px;
    top: 50%;
    z-index: 1000;
  }
  .what-we-do {
    color: #e77817 !important;
  }
  .home-4-sub-1 h2 {
    color: #121212;
    font-size: 50px;
    font-weight: 600;
  }
  .home-4-sub-1 p {
    color: #282735;
    font-size: 18px;
    font-weight: 400;
    max-width: 800px;
    line-height: 28px;
    text-align: center;
  }
  .home-4-sub-1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .small-div h4 {
    color: #ffffff;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 600px;
  }
  .small-div p {
    color: #ffffff;
    font-size: 14px;
    font-weight: 450px;
    max-width: 247px;

    line-height: 18px;
  }
  .inner-small-div-1,
  .inner-small-div-2,
  .inner-small-div-3 {
    background-size: cover;
    background-repeat: no-repeat;
    height: 418px;
    max-width: 337px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    justify-content: flex-end;
    padding: 20px;
    padding-bottom: 40px;
  }

  .all-home-6-sub-2 {
    flex: 1; /* Take remaining space */
    overflow-x: auto; /* Enable horizontal scrolling */
  }

  .home-4 {
    margin-top: 100px;
    background: #fffcf9;
    padding-bottom: 80px;
  }
  .home-4-p {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .home-4-sub-10 {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .home-4-sub-2 {
    display: flex;
    gap: 15px;
    min-width: 1000px;
  }
  .all-home-6-sub-2::-webkit-scrollbar {
    height: 2px; /* Set scrollbar width */
  }

  .all-home-6-sub-2::-webkit-scrollbar-thumb {
    background: #888; /* Scrollbar thumb color */
    border-radius: 2px; /* Optional for rounded scrollbar */
  }

  .all-home-6-sub-2::-webkit-scrollbar-thumb:hover {
    background: #555; /* Thumb hover color */
  }

  .all-home-6-sub-2::-webkit-scrollbar-track {
    background: #f1f1f1; /* Scrollbar track color */
  }

  /* Hide Up and Down Arrows in Scrollbar */
  .all-home-6-sub-2::-webkit-scrollbar-button {
    display: none; /* Hides the arrows */
  }
  .inner-home-4-upper h4 {
    color: #34302f;
    font-size: 20px;
    font-weight: 600;
  }
  .inner-home-4-upper p {
    color: #8f8d8c;
    font-size: 17px;
    font-weight: 450;
  }
  .inner-home-4-upper {
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 15px;
  }
  .bed-icon-div {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .bed-icon-div p {
    color: #34302f !important;
    font-size: 17px;
    font-weight: 600;
  }
  .bed-div p {
    color: #8f8d8c;
    font-size: 14px;
    font-weight: 450;
  }
  .bed-div {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .all-bed-div {
    display: flex;
    padding: 20px;
    justify-content: space-between;
  }
  .down-inner-div h4 {
    color: #34302f;
    font-weight: 600;
    font-size: 24px;
  }
  .down-inner-div {
    display: flex;

    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-top: 1px solid #34302f1a;
  }
  .view-detail {
    border: 1px solid #34302f33;
    width: 115px;
    height: 40px;
    display: flex;
    text-decoration: none;
    justify-content: center;
    align-items: center;
    color: #34302f;
    font-weight: 600;
    font-size: 11px;
    border-radius: 100px;
  }
  .text-home-4-inner {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .home-4-inner-all-div {
    width: 343px;
    border: 1px solid #34302f1a;
    border-radius: 12px;
    position: relative;
  }
  .home-4-inner-all-div img {
    width: 343px;
    height: 260px;
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
    object-fit: cover;
  }
  .bed-icon-div img {
    width: 20px;
    height: 20px;
  }
  .sell {
    background: #06af47;
    width: 51px;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    height: 24px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  .home-5 {
    margin-top: 100px;
  }
  .rent {
    background: #ffa800 !important;
  }
  .all-home-5 {
    display: flex;
    gap: 20px;
  }
  .upper-home-5 h2 {
    color: #34302f;
    font-size: 45px;
    line-height: 45px;
    font-weight: 600;
    max-width: 440px;
  }
  .upper-home-5 p {
    color: #e77817;
    font-weight: 500;
    font-size: 16px;
  }
  .upper-home-5 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 50px;
  }
  .inner-home-7 p {
    text-align: center;
    color: #8f8d8c;
    line-height: 22px;
    font-size: 16px;
    font-weight: 450;
  }
  .inner-home-7 h4 {
    color: #34302f;
    font-size: 18px;
    font-weight: 600;
  }
  .inner-home-7 {
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 50%;
    padding: 20px;
    align-items: center;
    border-right: 1px solid #e4e4e4;
  }
  .right-inner {
    border: none;
  }
  .all-inner-home-7 {
    display: flex;
    flex-direction: column;
  }
  .new-inner-home-7 {
    display: flex;
  }
  .home-7 h2 {
    color: #34302f;
    font-size: 45px;
    margin-bottom: 80px;
    font-weight: 600;
    line-height: 45px;
    text-align: center;
  }
  .home-7 {
    margin-top: 100px;
  }
  .home-8 p {
    font-size: 20px;
    font-weight: 500;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }
  .home-8 span {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
  .home-8 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 70px;
  }
  .home-9 {
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    margin-top: 100px;
    flex-wrap: wrap;
    gap: 20px;
    padding-top: 100px;
    padding-bottom: 70px;
    justify-content: space-between;
    align-items: flex-end;
  }
  .right-inner-home-9 p {
    color: #ffffffa6 !important;
    font-size: 16px !important;
    font-weight: 450 !important;
    max-width: 249px !important;
  }
  .right-inner-home-9 h6 {
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
  }
  .right-inner-home-9 {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .left-home-new-new {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }
  .inner-home-9 {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .left-home-9 p {
    color: #ffffff;
    font-size: 20px;
    font-weight: 450;
  }
  .left-home-9 h2 {
    color: #ffffff;
    font-size: 45px;
    font-weight: 600;
    line-height: 50px;
    max-width: 412px;
  }
  .left-home-9 {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
  .h-get-start {
    border: 1px solid #e4e4e4;
    border-radius: 100px;
    width: 172px;
    height: 53px;
    display: flex;
    text-decoration: none;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-weight: 600;
    font-size: 13px;
  }
  .left-home-10 {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .left-home-10 p {
    color: #8f8d8c;
    font-size: 16px;
    font-weight: 450px;
    max-width: 368px;
  }

  .left-home-10 h2 {
    color: #34302f;
    font-size: 45px;
    font-weight: 600;
    max-width: 409px;
    line-height: 50px;
  }
  .client-p {
    color: #e77817 !important;
  }
  .client-name {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .client-name h4 {
    color: #34302f;
    font-size: 18px;
    font-weight: 500;
  }
  .star-icons {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .client-info {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .home-10 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 100px;
  }
  .come-back {
    display: none;
  }
  .come-slide {
    display: none;
  }
  .come-slide-btn {
    display: none;
  }
  /* Flex container to align both sections side by side */
  .flex-container {
    position: relative;
    margin-top: 50px;
  }
.services-text h4 {
    font-weight: 600;
    font-weight: 28px;
}
.services-text p {
    font-weight: 400;
    font-weight: 18px;
    line-height: 23px;
    max-width: 544px;
}
.choose-div-header h2 {
    color: #121212;
    max-width: 440px;
    line-height: 100%;
    font-weight: 600;
    font-size: 50px;
    text-align: center;
}
.choose-div-header {
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
}
.choose-div-sub h4 {
    color: #121212;
    font-weight: 600;
    font-size: 24px;
}
.choose-div-sub p {
    line-height: 28px;
    font-weight: 400;
    font-size: 18px;
    max-width: 337px;
}
.choose-div-sub {
    display: flex;
    flex-direction: column;
    gap: 15px;
}
.choose-div-body {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}
.choose-div-all {
    display: flex;
    flex-direction: column;
    gap: 30px;
    background: #fffcf9;
    padding-bottom: 80px;
    padding-top: 80px;
}
  @media (max-width: 992px) {
    .flex-container {
      flex-direction: column;
    }
    .be-gone {
      display: none;
    }
    .gone-slide {
      display: none !important;
    }
    .come-slide {
      display: block !important;
    }
    .come-slide-btn {
      display: flex;
    }
    .come-back {
      display: block !important;
      margin-bottom: 100px !important;
    }
    .home-6 {
      margin-bottom: 20px !important;
    }
    .home-2-2,
    .home-6 {
      align-items: flex-start;
      flex-direction: column;
    }

    .all-home-6-sub-2 {
      max-width: 1000px;
    }
  }
  @media (max-width: 1130px) {
    .all-home-5 {
      flex-wrap: wrap;
    }
    .modal-content {
      max-width: 90% !important;
      height: 60%;
    }
  }
  @media (max-width: 1000px) {
    .home-2 {
      flex-wrap: wrap;
      padding: 20px;
    }
  }

  @media (max-width: 630px) {
    .home-10-img {
      width: 450px;
    }

    .home-1 h1 {
      font-size: 48px;
      line-height: 50px;
    }
    .gallery-inner {
      flex-wrap: wrap;
    }
     .galery-div {
      width: 100%;
      flex: 0 0 100%;
    }
     .nav-btn {
      display: none;
    }
    .circle-arrow-one, .circle-arrow-two {
        display: none;
    }
  }
  @media (max-width: 500px) {
    .home-2-sub {
      border: none;
    }
    .home-3-img {
      width: 350px;
    }
    .home-10-img {
      width: 350px;
    }
    
   
   
  }
  @media (max-width: 400px) {
   
    .inner-small-div-1,
    .inner-small-div-2,
    .inner-small-div-3 {
      width: 300px;
    }
    .home-10-img {
      width: 280px;
    }
  }
  .sub-about-1 p {
    font-size: 16px;
    font-weight: 450;
  }
  .sub-about-1-p {
    color: #e77817 !important;
  }
  .sub-about-1 h2 {
    color: #34302f;
    font-size: 45px;
    line-height: 50px;
    font-weight: 600;
    max-width: 481px;
  }
  .sub-about-1 {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .about-1 p {
    color: #8f8d8c;
    font-size: 16px;
    font-weight: 450;
    max-width: 367px;
  }
  .about-1 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 100px;
    gap: 20px;
    flex-wrap: wrap;
  }
  .about-2 {
    padding: 100px 24px;
    padding-bottom: 20px;
  }
  .about-2 img {
    max-width: 1300px;
  }
  .orange-text {
    color: #e77817 !important;
    font-size: 16px;
    font-weight: 450;
  }
  .real-estate p {
    color: #34302f !important;
    font-size: 50px;
    font-weight: 500;
  }
  .real-estate {
    border: 1px solid #34302f1a;
    border-radius: 100px;
    max-width: 382px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  .get-stated {
    background: #34302f;
    width: 175px;
    height: 55px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: #ffffff;
    font-weight: 600;
    font-size: 13px;
  }
  .about-3-inner p {
    color: #282735;
    font-weight: 400;
    max-width: 550px;
    font-size: 18px;
    line-height: 28px;
  }
  .about-3-inner h2 {
    color: #121212;
    font-weight: 600;
    font-size: 50px;
    line-height: 55px;
  }
  .about-1 h2 {
    color: #34302f;
    font-weight: 600;
    font-size: 45px;
    line-height: 50px;
    max-width: 382px;
  }
  .about-3-inner {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 50px;
  }
  .about-3 {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
    margin-top: 80px;

  }
  .inner-about-4 img {
    width: 60px;
    height: 60px;
  }
  .inner-about-4 {
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-content: center;
    align-items: center;
    border: 1px solid #34302f1a;
    background: #ffffff;
    width: 251px;
    padding: 25px;
    border-radius: 10px;
  }
  .inner-about-4 h4 {
    color: #34302f;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
  }
  .inner-about-4 p {
    color: #8f8d8c;
    font-size: 16px;
    font-weight: 450;
    max-width: 168px;
    text-align: center;
  }
  .inner-about-4-div {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    flex-wrap: wrap;
  }
  .about-4-down p {
    color: #34302f;
    font-size: 18px;
    font-weight: 500;
  }
  .about-4-down {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;
  }
  .about-4 h2 {
    color: #34302f;
    font-size: 45px;
    font-weight: 600px;
    text-align: center;
  }
  .about-4 {
    display: flex;
    flex-direction: column;
    gap: 50px;
    background: #f7f7f7;
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .about-5 h4 {
    background: #34302f;
    width: 118px;
    height: 32px;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 12px;
    font-size: 600;
  }
  .about-5 p {
    color: #34302f;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
  }
  .about-5 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 70px 0px;
  }
  .about-6 {
    display: flex;
    gap: 15px;
    overflow-x: auto;
  }
  .all-about-6 {
    min-width: 1100px;
    overflow: hidden;
  }
  .about-6::-webkit-scrollbar {
    height: 2px; /* Set scrollbar width */
  }

  .about-6::-webkit-scrollbar-thumb {
    background: #888; /* Scrollbar thumb color */
    border-radius: 2px; /* Optional for rounded scrollbar */
  }

  .about-6::-webkit-scrollbar-thumb:hover {
    background: #555; /* Thumb hover color */
  }

  .about-6::-webkit-scrollbar-track {
    background: #f1f1f1; /* Scrollbar track color */
  }

  /* Hide Up and Down Arrows in Scrollbar */
  .about-6::-webkit-scrollbar-button {
    display: none; /* Hides the arrows */
  }

  .about-2-inner-1 {
    display: flex;
    align-items: center;
    gap: 40px;
    margin-top: 80px;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 100px;
  }

  .about-2-inner-1 p {
    text-align: center;
    max-width: 700px;
    color: #34302f;
  }

  .link-container {
    width: 250px;
    padding: 5px 0px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border-radius: 100px;
    border: 1px solid #34302f1a;
    box-shadow: 0px 15px 45px 0px #00000013;
  }
  .about-3-img {
    width: 500px;
  }
  .link {
    text-decoration: none;
    color: black;
    font-size: 14px;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: 450px;
  }
  .link.active {
    background: black;
    width: 98px;
    height: 51px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }
.choose-div-icon {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #12121229;

}
 .choose-div-icon img {
  width: 20px;
  height: 20px;
 }
  @media (max-width: 1350px) {
    .about-2 img {
      max-width: 1200px;
    }
  }
  @media (max-width: 1250px) {
    .about-2 img {
      max-width: 1100px;
    }
  }
  @media (max-width: 1150px) {
    .about-2 img {
      max-width: 900px;
    }
  }
    @media (max-width: 1024px) {
.home-3 {
    flex-wrap: wrap-reverse;
}
.about-3 {
    flex-wrap: wrap;
}
.over-4-header-all {
    flex-wrap: wrap;
}
    }
  @media (max-width: 950px) {
    .about-2 img {
      max-width: 700px;
    }
    .choose-div-body {
        flex-wrap: wrap;
    }
  }
  @media (max-width: 750px) {
    .about-2 img {
      max-width: 500px;
    }
  }
  @media (max-width: 678px) {
    .about-3-img {
      width: 500px;
    }
    .home-1,
    .home-1-img-banner {
      height: 50vh;
    }
    .home-1 {
      gap: 20px;
      padding-bottom: 10px;
    }
    .home-3 img, .about-3 img {
        width: 500px;
    }
  }
  @media (max-width: 550px) {
    
   
      .home-3 img, .about-3 img  {
        width: 400px;
    }
     .over-4 {
      margin: 0px 0px !important;
      margin-top: 80px !important;
    }
     .home-4, .about-3 {
      padding-bottom: 0px !important;
      margin-top: 80px;
     }
  }
    @media (max-width: 450px) {
          .home-3 img, .about-3 img  {
        width: 350px;
    }
     .home-1 {
      padding-left: 20px;
    }
}
    @media (max-width: 400px) {
          .home-3 img, .about-3 img  {
        width: 330px;
    }
   
}
  @media (max-width: 360px) {
    .about-2 img {
      max-width: 250px;
    }
    .about-3-img {
      width: 250px;
    }
           .home-3 img, .about-3 img  {
        width: 300px;
    }
  }
`;

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { homeObject, aboutObject, loading, error } = useSelector(
    (state) => state.content || []
  );
  console.log(homeObject);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexTwo, setCurrentIndexTwo] = useState(0);
const intervalRef = useRef(null);
const isPausedRef = useRef(false);
const isPausedTwoRef = useRef(false);

  const [currentDiv, setCurrentDiv] = useState(0);
  const [currentIndexp, setCurrentIndexp] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const itemsPerView = 2;
  const itemsPerViewTwo = 1;
  console.log(selectedImage);
  const [activeLink, setActiveLink] = useState("home");

  const slider = homeObject?.data?.slider || [];
  const about = homeObject?.data?.about;
  const footerTitle = homeObject?.data?.footerTitle;
  const moreServices = homeObject?.data?.moreServices;
  const newsletter = homeObject?.data?.newsletter;
  const portfolio = homeObject?.data?.portfolio;
  const servicess = homeObject?.data?.services;
  const whyChoseUs = homeObject?.data?.whyChoseUs;
  const sectionOne = aboutObject?.data?.sectionOne;
  const sectionTwo = aboutObject?.data?.sectionTwo;
  const sectionThree = aboutObject?.data?.secThree;

  const [currentSlide, setCurrentSlide] = useState(slider[0]);
  // const currentSlide = slider[currentIndex];
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // ✅ Autoplay enabled
    autoplaySpeed: 5000, // ✅ 5 seconds (adjust as needed)
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(slider[newIndex]),
  };

  useEffect(() => {
    dispatch(fetchHomepage()); // Call API on component mount
  }, [dispatch]);
  useEffect(() => {
    dispatch(fetchObjectpage()); // Call API on component mount
  }, [dispatch]);

  const scrollRef = useRef();

  const scroll = (direction) => {
    const scrollAmount = 300; // width + gap
    if (scrollRef.current) {
      direction === "left"
        ? scrollRef.current.scrollBy({
            left: -scrollAmount,
            behavior: "smooth",
          })
        : scrollRef.current.scrollBy({
            left: scrollAmount,
            behavior: "smooth",
          });
    }
  };

  const services = servicess?.serviceList || [];
  const servicesTwo = servicess?.serviceList || [];

  const maxIndex = Math.ceil(services?.length / itemsPerView) - 1;
  const maxIndexTwo = Math.ceil(servicesTwo?.length / itemsPerViewTwo) - 1;

  const handleNextMobile = () => {
    if (currentIndexTwo < maxIndexTwo) {
      setCurrentIndexTwo((prev) => prev + 1);
    }
  };

  const handlePrevMobile = () => {
    if (currentIndexTwo > 0) {
      setCurrentIndexTwo((prev) => prev - 1);
    }
  };



  const startAutoSlide = (servicesLength, itemsPerView) => {
  const totalSlides = Math.ceil(servicesLength / itemsPerView);

  intervalRef.current = setInterval(() => {
    if (!isPausedRef.current) {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    }
  }, 5000);
};





useEffect(() => {
  if (!services || services.length === 0) return;

  startAutoSlide(services.length, itemsPerView);

  return () => {
    clearInterval(intervalRef.current);
  };
}, [services, itemsPerView]);






  useEffect(() => {
  if (!servicesTwo || servicesTwo.length <= 1) return;

  const totalSlidesTwo = Math.ceil(servicesTwo.length / itemsPerViewTwo);

  const interval = setInterval(() => {
    if (!isPausedTwoRef.current) {
      setCurrentIndexTwo((prev) => (prev + 1) % totalSlidesTwo);
    }
  }, 3000);

  return () => clearInterval(interval);
}, [servicesTwo, itemsPerViewTwo]);


  const handleNext = () => {
    if (currentIndex < maxIndex) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const visibleImages = 2;
  const totalSlides = Math.ceil((portfolio?.portfolioList?.length || 0) / visibleImages);

  const handlePrevTwo = () => {
    if (currentIndexp > 0) {
      setCurrentIndexp(prev => prev - 1);
    }
  };

  const handleNextTwo = () => {
    if (currentIndexp < totalSlides - 1) {
      setCurrentIndexp(prev => prev + 1);
    }
  };

  const translateXPercent = currentIndexp * 101;


  const handleGoToOtherServices = (id) => {
    navigate(`/otherservices/details/${id}`);
  };

  // const handleMovetoDetailsService = (id) => {
  //   navigate(`/management/${id}`)
  // }

  let parsedContent = [];
  try {
    parsedContent = JSON.parse(about?.paragraph_one);
  } catch (e) {
    console.error("Failed to parse content:", e);
  }


  const handleLinkClick = (link) => {
    setActiveLink(link);
     const section = document.getElementById(link);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      console.log(link);
      
    }
  };

  console.log(parsedContent);

  return (
    <HomeRap>
        <div className="slider-wrapper">
      <Slider {...settings}>
        {slider?.map((slide, index) => (
          <div key={index}>
            <div
              id="home"
              className="home-1"
              style={{ position: "relative", overflow: "hidden" }}
            >
              <img
                className="home-1-img-banner"
                src={`https://admin.abrigo-llc.com/${slide?.banner}`}
                alt={`Slide ${index}`}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: -1,
                }}
              />
              <div style={{ position: "relative" }}>
                <h1>{slide?.title}</h1>

              </div>
              <p>{slide?.sub_title}</p>
              <Link onClick={() => handleLinkClick("contact")} className="get-in-touch">Get in Touch</Link>
            </div>
          </div>
        ))}
      </Slider>
      </div>

      <div id="about" className="home-3 containers">
        <img
          className="home-3-img"
          src={`https://admin.abrigo-llc.com/${about?.banner}`}
          alt=""
        />
        <div className="sub-home-3">
          <h2>{about?.title}</h2>
          <div
            className=""
            dangerouslySetInnerHTML={{ __html: about?.content }}
          ></div>
        
        </div>
      </div>
      
      {/* <div className="about-3 containers">
       
        <div className="about-3-inner">
            <h2>{sectionTwo?.title}</h2>
          <div
            className=""
            dangerouslySetInnerHTML={{ __html: sectionTwo?.content }}
          ></div>
       
        </div>
            <img
          className="about-3-img"
          src={`https://admin.abrigo-llc.com/${sectionTwo?.banner}`}
          alt=""
        />
      </div> */}

      <div id="services" className="containers home-4">
        <div className="home-4-sub-1" style={{ flex: "1" }}>
            <h2 >{servicess?.serviceTitle?.sub_title}</h2>
            {/* <p>{servicess?.serviceTitle?.overview}</p> */}
           
 <div
            className="home-4-p"
            dangerouslySetInnerHTML={{ __html: servicess?.serviceTitle?.overview}}
          ></div>
        
          </div>

        <div className="flex-container">
          {/* Left Section */}
              <div className="circle-arrow circle-arrow-one" onClick={handlePrev}>
                <Icon icon="formkit:arrowleft" width="28" height="28" />
              </div>
              <div className="circle-arrow circle-arrow-two" onClick={handleNext}>
                <Icon icon="formkit:arrowright" width="28" height="28" />
              </div>

          {/* Right Section (Slider) */}
 <div
  className="gone-slide"
  style={{ overflow: "hidden" }}
  onMouseEnter={() => {
     console.log('Paused on hover');
    isPausedRef.current = true;
  }}
  onMouseLeave={() => {
    console.log('Resumed on leave');
    isPausedRef.current = false;
  }}
>
  <div
    style={{
      display: "flex",
      transition: "transform 0.5s ease-in-out",
      transform: `translateX(-${
        (100 / services?.length) * currentIndex * itemsPerView
      }%)`,
      width: `${(98 / itemsPerView) * services?.length}%`,
      gap: "10px",
    }}
  >
    {services?.map((service, index) => (
      <div
        className="services-text"
        key={index}
        style={{
          flex: `0 0 ${100 / services?.length}%`,
          backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.3), #000), url(https://admin.abrigo-llc.com/${service?.banner})`,
          height: "418px",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          padding: "20px",
          paddingBottom: "40px",
          display: "flex",
          gap: "15px",
          flexDirection: "column",
          justifyContent: "flex-end",
          color: "#fff",
        }}
      >
        <h4>{service.title}</h4>
        <p>{service.overview}</p>
      </div>
    ))}
  </div>
</div>



         <div
  className="come-slide"
  style={{ overflow: "hidden" }}
  onMouseEnter={() => { isPausedTwoRef.current = true; }}
  onMouseLeave={() => { isPausedTwoRef.current = false; }}
  onTouchStart={() => { isPausedTwoRef.current = true; }}
  onTouchEnd={() => { isPausedTwoRef.current = false; }}
>
  <div
    style={{
      display: "flex",
      transition: "transform 0.5s ease-in-out",
      transform: `translateX(-${
        (98 / servicesTwo?.length) * currentIndexTwo * itemsPerViewTwo
      }%)`,
      width: `${(100 / itemsPerViewTwo) * servicesTwo?.length}%`,
      gap: "10px",
    }}
  >
    {servicesTwo?.map((service, index) => (
      <div
        key={index}
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.3), #000), url(https://admin.abrigo-llc.com/${service?.banner})`,
          height: "418px",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "12px",
          padding: "20px",
          paddingBottom: "40px",
          display: "flex",
          gap: "20px",
          flexDirection: "column",
          justifyContent: "flex-end",
          color: "#fff",
        }}
      >
        <h4>{service.title}</h4>
        <p>{service.overview}</p>
      </div>
    ))}
  </div>
</div>

        </div>
      </div>

      {/* <div className="home-8 containers">
        <img src="/images/mark_green.png" alt="" />
        <p>{moreServices?.moreTitle?.bottom_paragraph}</p>
      </div> */}
      {/* <div
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, #000000 100%), url("https://admin.abrigo-llc.com/${whyChoseUs?.banner}")`,
        }}
        className="home-9 containers"
      >
        <div className="left-home-9">
          <p>{whyChoseUs?.title}</p>
          <h2>{whyChoseUs?.sub_title}</h2>
          <div className="left-home-new-new">
            <div className="inner-home-9">
              <img src="/images" alt="" />
              <div className="right-inner-home-9">
                <h6> {whyChoseUs?.first_title}</h6>
                <p>{whyChoseUs?.first_content}</p>
              </div>
            </div>
            <div className="inner-home-9">
              <img src="/images" alt="" />
              <div className="right-inner-home-9">
                <h6> {whyChoseUs?.second_title}</h6>
                <p>{whyChoseUs?.second_content}</p>
              </div>
            </div>
            <div className="inner-home-9">
              <img src="/images" alt="" />
              <div className="right-inner-home-9">
                <h6>{whyChoseUs?.third_title}</h6>
                <p>{whyChoseUs?.third_content}</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div id="company" className="over-4 containers">
        <div className="over-4-header-all">
        <div className="over-4-header">
          <p className="orange-p">{portfolio?.heading?.title}</p>
          <h4>{portfolio?.heading?.sub_title}</h4>
        </div>
                  <p>{portfolio?.heading?.content}</p>

        </div>



        

        <div className="gallery-container">
      <button onClick={handlePrevTwo} className="nav-btn left-btn">
        ◀
      </button>

      <div className="gallery-slider">
        <div
          className="gallery-inner"
          style={{ transform: `translateX(-${translateXPercent}%)` }}
        >
          {portfolio?.portfolioList?.map((item, index) => (
            <div className="galery-div" key={index}>
              <div
                className="banner-wrapper"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setSelectedImage(item);
                }}
              >
                <img
                  src={`https://admin.abrigo-llc.com/${item?.image}`}
                  alt={`pic-${index}`}
                  className="gallery-img"
                />
                {item?.video && <div className="play-button">▶</div>}
              </div>

              <p>{item?.content}</p>
              <a
                href={item?.project_link}
                className="banner-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn More
              </a>
            </div>
          ))}
        </div>
      </div>

      <button onClick={handleNextTwo} className="nav-btn right-btn">
        ▶
      </button>
    </div>

        {selectedImage && (
          <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              {selectedImage?.video ? (
                // If it's YouTube or YouTube short link
                selectedImage.video.includes("youtube") ||
                selectedImage.video.includes("youtu.be") ? (
                  <iframe
                    width="100%"
                    height="100%"
                    src={`${
                      selectedImage.video.includes("?")
                        ? `${selectedImage.video}&playsinline=1&autoplay=1`
                        : `${selectedImage.video}?playsinline=1&autoplay=1`
                    }`}
                    title="Video"
                    frameBorder="0"
                    allow="autoplay; encrypted-media; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  // For mp4 or other video formats
                  <video
                    width="100%"
                    height="100%"
                    controls
                    playsInline // ✅ iPhone inline support
                    autoPlay // ✅ autoplay when modal opens
                  >
                    <source src={selectedImage.video} />
                    Your browser does not support this video format.
                  </video>
                )
              ) : (
                <img
                  src={`https://admin.abrigo-llc.com/${selectedImage?.image}`}
                  alt="enlarged"
                />
              )}

              <button
                onClick={() => setSelectedImage(null)}
                className="close-btn"
              >
                ✖
              </button>
            </div>
          </div>
        )}
      </div>
    
      <div className="choose-div-all  containers">
        <div className="choose-div-header">
            <p className="orange-p">Why choose us</p>
            <h2>We're reliable and trusted by clients</h2>
        </div>
        <div className="choose-div-body">
            <div className="choose-div-sub">
                <div className="choose-div-icon">
                  <img src={`https://admin.abrigo-llc.com/${whyChoseUs?.icon_one}`} alt="" />
                </div>
                <h4>{whyChoseUs?.first_title}</h4>
                <p>{whyChoseUs?.first_content}</p>
            </div>
             <div className="choose-div-sub">
                <div className="choose-div-icon">
                                    <img src={`https://admin.abrigo-llc.com/${whyChoseUs?.icon_two}`} alt="" />

                </div>
                <h4>{whyChoseUs?.second_title}</h4>
                <p>{whyChoseUs?.second_content}</p>
            </div>
             <div className="choose-div-sub">
                <div className="choose-div-icon">
                                    <img src={`https://admin.abrigo-llc.com/${whyChoseUs?.icon_three}`} alt="" />

                </div>
                <h4>{whyChoseUs?.third_title}</h4>
                <p>{whyChoseUs?.third_content}</p>
            </div>
        </div>
      </div>
    </HomeRap>
  );
};
export default Home;
